import { gql, useQuery } from "@apollo/client";
import React, { useState } from "react";
import { Loading } from "../../../../components/Loading";

const QUERY_PRODUCT_BY_CODE = gql`
  query productByCode($code: String!) {
    productByCode(code: $code) {
      id
      picture
      code
      price
      stockQty
    }
  }
`;

interface Props {
  data: any;
  isAdd: boolean;
  onAdd: () => void;
  onRemove: () => void;
  id: string;
}

export function AdsCampaignField(props: Props) {
  const [codeinput, setCodeInput] = useState("");
  const [code, setCode] = useState("");
  const [biding, setBiding] = useState("");
  const [budget, setBudget] = useState("");
  const [type, setType] = useState("LIVE");
  const [productId, setProductId] = useState("");

  const { data, loading } = useQuery(QUERY_PRODUCT_BY_CODE, {
    variables: {
      code,
    },
    skip: !code,
    fetchPolicy: "no-cache",
    onCompleted: (res) => {
      if (res.productByCode) {
        setProductId(res.productByCode.id);
      } else {
        setCode("");
        setCodeInput("");
        alert("Product not found!");
      }
    },
  });

  const handleKeyPress = (e: any) => {
    if (e.keyCode === 13) {
      if (codeinput) {
        setCode(codeinput.trim());
      }
    }
  };

  const handleBlur = () => {
    if (codeinput) {
      setCode(codeinput.trim());
    }
  };

  if (loading) {
    return (
      <tr>
        <td>
          <Loading />
        </td>
      </tr>
    );
  }

  return (
    <tr>
      <td>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {data !== undefined && data.productByCode && (
            <img
              src={data.productByCode.picture}
              alt=""
              style={{
                width: 65,
                height: 65,
                borderRadius: 4,
                objectFit: "cover",
              }}
            />
          )}
          <div className={data !== undefined ? "ml-4" : ""}>
            <input
              className="form-control form-control-sm form-secondary"
              placeholder="Enter product code here..."
              value={codeinput}
              onChange={(e) => setCodeInput(e.target.value)}
              onKeyDown={handleKeyPress}
              onBlur={handleBlur}
              name="code"
            />
            {data !== undefined && data.productByCode && (
              <>
                <small className="text-success">Sale Price: {data.productByCode.price} USD</small>
                <br />
                <small>Stock: {data.productByCode.stockQty | 0}</small>
              </>
            )}
          </div>
          {productId && (
            <i id={"product" + props.id} style={{ display: "none" }}>
              {productId}
            </i>
          )}
        </div>
      </td>
      <td>
        <input
          id={"biding" + props.id}
          placeholder="Enter biding here..."
          className="form-control form-control-sm form-secondary"
          value={biding}
          onChange={(e) => setBiding(e.target.value)}
          type="number"
          name="biding"
        />
      </td>
      <td>
        <input
          id={"budget" + props.id}
          placeholder="Enter budget here..."
          className="form-control form-control-sm form-secondary"
          value={budget}
          onChange={(e) => setBudget(e.target.value)}
          type="number"
          name="budget"
        />
      </td>
      <td style={{ width: 150 }}>
        <select
          className="form-control form-control-sm form-secondary"
          value={type}
          onChange={(e) => setType(e.target.value)}
        >
          <option value="LIVE">Product Live</option>
          <option value="CLICK">Pay Per Click</option>
        </select>
        <i id={"type" + props.id} style={{ display: "none" }}>
          {type}
        </i>
      </td>
      <td>
        {props.isAdd ? (
          <span
            className="os-icon os-icon-plus-circle text-success"
            style={{ fontSize: 18, cursor: "pointer" }}
            onClick={props.onAdd}
          ></span>
        ) : (
          <span
            className="os-icon os-icon-x-circle text-danger"
            style={{ fontSize: 18, cursor: "pointer" }}
            onClick={props.onRemove}
          ></span>
        )}
      </td>
    </tr>
  );
}
